import type { MonitorAndProtectParams } from "app/pages/digital-marketing/monitor-and-protect/app/keywords/routes.types";

import { ROUTES } from "../../../app/keywords/constants";
import type { RedirectHandler } from "../types";

const DEFAULT_DURATION = "28d";

function isValidDurationForNonAdsPages(duration: string | undefined): boolean {
    return !duration || duration === DEFAULT_DURATION;
}

// eslint-disable-next-line @typescript-eslint/require-await
export const durationResetHandler: RedirectHandler = async (transition) => {
    const toState = transition.to();
    const fromState = transition.from();
    const currentParams = transition.params() as MonitorAndProtectParams;

    const isNavigatingToAdsPage = toState.name === ROUTES.ADS.stateName;
    const isNavigatingFromAdsPage = fromState.name === ROUTES.ADS.stateName;

    if (isNavigatingToAdsPage || !isNavigatingFromAdsPage) {
        return void 0;
    }

    const currentDuration = currentParams.duration as string | undefined;

    if (!isValidDurationForNonAdsPages(currentDuration)) {
        return {
            params: {
                ...currentParams,
                duration: DEFAULT_DURATION,
            },
        };
    }

    return void 0;
};
